import React from 'react';
import { Crown, AlertCircle, CheckCircle } from 'lucide-react';
import { useSubscription } from '../hooks/useSubscription';
import { getProductByPriceId } from '../stripe-config';

export function SubscriptionStatus() {
  const { subscription, loading, isActive } = useSubscription();

  if (loading) {
    return (
      <div className="bg-gray-50 rounded-lg p-4">
        <div className="animate-pulse flex items-center">
          <div className="w-5 h-5 bg-gray-300 rounded mr-3"></div>
          <div className="h-4 bg-gray-300 rounded w-32"></div>
        </div>
      </div>
    );
  }

  if (!subscription || !isActive) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <div className="flex items-center">
          <AlertCircle className="w-5 h-5 text-yellow-600 mr-3" />
          <div>
            <p className="text-yellow-800 font-medium">Plano Gratuito</p>
            <p className="text-yellow-700 text-sm">Funcionalidades limitadas</p>
          </div>
        </div>
      </div>
    );
  }

  const product = getProductByPriceId(subscription.price_id || '');

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-4">
      <div className="flex items-center">
        <CheckCircle className="w-5 h-5 text-green-600 mr-3" />
        <div>
          <div className="flex items-center">
            <Crown className="w-4 h-4 text-green-600 mr-1" />
            <p className="text-green-800 font-medium">
              {product?.name || 'EventPour Pro'}
            </p>
          </div>
          <p className="text-green-700 text-sm">Assinatura ativa</p>
        </div>
      </div>
    </div>
  );
}